import { useTranslation } from 'react-i18next';
import { ChangeEvent, useContext } from 'react';
import { Form, Input, FormContext } from 'dash-ui';
import { AccountStatusesEnum } from 'dash-common';

import { OrganizationUser } from 'gql/generated.graphql';
import { FormFields } from 'pages/OrganizationPage/OrganizationDetailsPage/components/OrganizationDetailsTabs/components/OrganizationUsers/components/SaveOrganizationUsersModal/constants/constants';
import useValidation from 'pages/OrganizationPage/OrganizationDetailsPage/components/OrganizationDetailsTabs/components/OrganizationUsers/components/SaveOrganizationUsersModal/hooks/useValidation';

const GeneralInputs = ({ orgUser }: { orgUser?: OrganizationUser }) => {
  const { t } = useTranslation(['forms', 'common', 'pages']);
  const { formState, formErrors, stateHandlers } = useContext(FormContext);
  const valid = useValidation();

  const onChange =
    (fieldName: FormFields) => (e: ChangeEvent<HTMLInputElement>) => {
      stateHandlers[fieldName](e.target.value);
      valid(fieldName, e.target.value);
    };

  return (
    <>
      <Form.Group w="100%" mt={3}>
        <Form.Label required>{t('forms:labels.firstName')}</Form.Label>
        <Input
          w="100%"
          value={formState.firstName || ''}
          placeholder={t('forms:placeholders.firstName') || ''}
          onChange={onChange(FormFields.FirstName)}
          $errorType={formErrors[FormFields.FirstName]?.type}
        />
        <Form.Feedback $errorType={formErrors[FormFields.FirstName]?.type}>
          {formErrors[FormFields.FirstName]?.message}
        </Form.Feedback>
      </Form.Group>
      <Form.Group w="100%" mt={3}>
        <Form.Label required>{t('forms:labels.lastName')}</Form.Label>
        <Input
          w="100%"
          value={formState.lastName || ''}
          placeholder={t('forms:placeholders.lastName') || ''}
          onChange={onChange(FormFields.LastName)}
          $errorType={formErrors[FormFields.LastName]?.type}
        />
        <Form.Feedback $errorType={formErrors[FormFields.LastName]?.type}>
          {formErrors[FormFields.LastName]?.message}
        </Form.Feedback>
      </Form.Group>
      <Form.Group w="100%" mt={3}>
        <Form.Label required>{t('forms:labels.email')}</Form.Label>
        <Input
          w="100%"
          type="email"
          value={formState.email || ''}
          placeholder={t('forms:placeholders.email') || ''}
          onChange={onChange(FormFields.Email)}
          disabled={
            orgUser &&
            ![AccountStatusesEnum.ADDED, AccountStatusesEnum.INVITED].includes(
              orgUser.account?.status as AccountStatusesEnum
            )
          }
          $errorType={formErrors[FormFields.Email]?.type}
        />
        <Form.Feedback $errorType={formErrors[FormFields.Email]?.type}>
          {formErrors[FormFields.Email]?.message}
        </Form.Feedback>
      </Form.Group>
    </>
  );
};

export default GeneralInputs;
